// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as LoaderComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/loader/LoaderComponent.bs.js";
import * as DriverSuspensionListVMMapper from "../../vm-mapper/suspension-list/DriverSuspensionListVMMapper.bs.js";
import * as DriverSuspensionListViewMapper from "../../vm-mapper/suspension-list/DriverSuspensionListViewMapper.bs.js";

function DriverSuspensionList$SuspensionLogs(Props) {
  var data = Props.data;
  var viewModel = DriverSuspensionListVMMapper.DriverSuspensionListVMMapper.getViewModel(data);
  return React.createElement("div", undefined, DriverSuspensionListViewMapper.DriverSuspensionListViewMapper.getView(viewModel));
}

var SuspensionLogs = {
  make: DriverSuspensionList$SuspensionLogs
};

var SuspensionLogsLoaderConfig = {};

var SuspensionLogsLoaderComponent = LoaderComponent$Catalyst.LoaderComponentWithoutRefresh(SuspensionLogsLoaderConfig);

function DriverSuspensionList$SuspensionLogsLoader(Props) {
  var driverUuid = Props.driverUuid;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  return React.createElement(SuspensionLogsLoaderComponent.make, {
              fetchData: (function (param) {
                  var RepoInstance = CrmRepoManager.getSuspensionRepo(undefined);
                  return Curry._2(RepoInstance.fetchSuspensionInfo, driverUuid, country);
                }),
              renderView: (function (data) {
                  return React.createElement(DriverSuspensionList$SuspensionLogs, {
                              data: data
                            });
                })
            });
}

var SuspensionLogsLoader = {
  SuspensionLogsLoaderConfig: SuspensionLogsLoaderConfig,
  SuspensionLogsLoaderComponent: SuspensionLogsLoaderComponent,
  make: DriverSuspensionList$SuspensionLogsLoader
};

export {
  SuspensionLogs ,
  SuspensionLogsLoader ,
  
}
/* SuspensionLogsLoaderComponent Not a pure module */
